<div class="row mb-3 mb-xl-0">
  <div class="col-12 col-md-4 col-xl-3 d-flex flex-column justify-content-end">
    <label class="form-label mb-1" translate>PRODUCT_ID</label>
    <input
      type="text"
      class="form-control mb-3"
      [ngbTypeahead]="productSearch"
      [resultFormatter]="productResultFormatter"
      [inputFormatter]="productInputFormatter"
      [(ngModel)]="productInputModel"
      (ngModelChange)="onProductModelChange($event)"
      placeholder="{{ 'SEARCH' | translate }}"
    />
  </div>

  @if (flowOptions?.length > 0) {
    <div class="col-12 col-md-4 col-xl-3 d-flex flex-column justify-content-end">
      <lib-gung-input-multi-select
        label="FLOWS"
        [optionsList]="flowOptions"
        (selectedValues)="setSelectedFlowId($event)"
        [singleSelection]="true"
        [previewField]="['id', ' - ', 'name']"
      ></lib-gung-input-multi-select>
    </div>
  }

  @if (userOptions?.length > 0) {
    <div class="col-12 col-md-4 col-xl-3 d-flex flex-column justify-content-end">
      <lib-gung-input-multi-select
        label="USERS"
        [optionsList]="userOptions"
        (selectedValues)="setSelectedUsername($event)"
        [singleSelection]="true"
        [previewField]="['id', ' - ', 'name']"
      ></lib-gung-input-multi-select>
    </div>
  }

  <div class="col-12 col-xl-3 d-flex flex-column justify-content-end">
    <div class="mb-3">
      <gung-button
        classes="btn-primary w-100"
        label="{{ 'START_DEBUG' | translate }}"
        icon="fa-solid fa-bug"
        [onClick]="debugProduct.bind(this)"
        [disable]="!productId || !selectedFlowId || !selectedUsername"
      />
    </div>
  </div>
</div>

@if (!!productDebugData && !loading && !productDebugData?.error) {
  <div class="row">
    <div class="col-12">

      <div class="settings-card">
        <div class="settings-card-header">
          <span class="settings-title">{{ 'DEBUG_CONDITIONS' | translate }}</span>
        </div>

        <div class="settings-card-body">
          <div class="settings-row">
            <span class="settings-label">{{ 'PRODUCT_EXISTS_IN_USER_ASSORTMENT' | translate }}</span>
            @if (productDebugData.isInAssortment) {
              <span class="settings-check settings-check-ok">{{ 'YES' | translate }} <i class="fa-solid fa-circle-check"></i></span>
            } @else {
              <span class="settings-check settings-check-fail">{{ 'NO' | translate }} <i class="fa-solid fa-circle-xmark"></i></span>
            }
          </div>

          <div class="settings-row">
            <span class="settings-label">
              {{ 'PRODUCT_BLOCKED' | translate }}
              @if (productDebugData.isProductBlocked && productBlockedExtraText) {
                <br /><small class="text-muted">{{ productBlockedExtraText | translate }}</small>
              }
            </span>
            @if (productDebugData.isProductBlocked) {
              <span class="settings-check settings-check-fail">{{ 'YES' | translate }} <i class="fa-solid fa-circle-xmark"></i></span>
            } @else {
              <span class="settings-check settings-check-ok">{{ 'NO' | translate }} <i class="fa-solid fa-circle-check"></i></span>
            }
          </div>

          <div class="settings-row">
            <span class="settings-label">{{ 'PRODUCT_FILTERED_OUT_BY_FLOW_PRODUCT_SETTINGS' | translate }}</span>
            <span class="d-flex align-items-center gap-2">
              @if (!productDebugData.flow.isProductInFlow) {
                <span class="settings-check settings-check-fail">{{ 'YES' | translate }} <i class="fa-solid fa-circle-xmark"></i></span>
              } @else {
                <span class="settings-check settings-check-ok">{{ 'NO' | translate }} <i class="fa-solid fa-circle-check"></i></span>
              }
              @if (flowConditionGroups.length > 0) {
                <button
                  type="button"
                  class="btn btn-link btn-sm p-0 align-baseline"
                  (click)="flowDetailsExpanded = !flowDetailsExpanded"
                >
                  {{ (flowDetailsExpanded ? 'HIDE_DETAILS' : 'SEE_DETAILS') | translate }}
                  <i
                    class="fa-solid ms-1"
                    [class.fa-chevron-up]="flowDetailsExpanded"
                    [class.fa-chevron-down]="!flowDetailsExpanded"
                  ></i>
                </button>
              } @else {
                <small class="fst-italic text-muted">{{ 'DEBUG_FLOW_HAS_NO_PRODUCT_CONDITIONS' | translate }}</small>
              }
            </span>
          </div>

          @if (flowDetailsExpanded && flowConditionGroups.length > 0) {
            <div class="flow-condition-panel">
              <div class="flow-condition-note">
                <i class="fa-solid fa-circle-info me-2 text-muted"></i>
                {{ 'DEBUG_FLOW_CONDITION_ANY_MATCH_HINT' | translate }}
              </div>
              @if (flowMatchFromSubProduct) {
                <div class="flow-condition-note flow-condition-note-warning">
                  <i class="fa-solid fa-triangle-exclamation me-2"></i>
                  {{ 'DEBUG_FLOW_CONDITION_MATCH_FROM_SUB_PRODUCT' | translate }}
                </div>
              }
              @if (flowSubProductBlocks) {
                <div class="flow-condition-note flow-condition-note-warning">
                  <i class="fa-solid fa-triangle-exclamation me-2"></i>
                  {{ 'DEBUG_FLOW_CONDITION_SUB_PRODUCT_BLOCKS' | translate }}
                </div>
              }
              @for (group of flowConditionGroups; track group.conditionIndex) {
                <div class="flow-condition-card">
                  <div class="flow-condition-card-header">
                    <i class="fa-solid fa-filter me-2 text-muted"></i>
                    {{ 'DEBUG_FLOW_CONDITION' | translate }} {{ group.conditionIndex + 1 }}
                    @if (group.match) {
                      <span class="badge rounded-pill bg-success ms-2">{{
                        'DEBUG_FLOW_CONDITION_MATCHES' | translate
                      }}</span>
                    } @else {
                      <span class="badge rounded-pill bg-secondary ms-2">{{
                        'DEBUG_FLOW_CONDITION_DOES_NOT_MATCH' | translate
                      }}</span>
                    }
                  </div>
                  <div class="table-responsive">
                    <table class="table table-sm mb-0 flow-condition-table">
                      <thead>
                        <tr>
                          <th>{{ 'DEBUG_FLOW_CONDITION_FIELD' | translate }}</th>
                          <th>
                            {{
                              'DEBUG_FLOW_CONDITION_PRODUCT_HAS_VALUE'
                                | translate: { id: productDebugData?.data?.product?.id || productId }
                            }}
                          </th>
                          <th>{{ 'DEBUG_FLOW_CONDITION_FLOW_INCLUDES' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (detail of group.details; track $index) {
                          <tr
                            [class.condition-pass]="detail.match === 'yes'"
                            [class.condition-fail]="detail.match === 'no'"
                          >
                            <td [attr.data-label]="'DEBUG_FLOW_CONDITION_FIELD' | translate">
                              <span class="flow-condition-key">{{ detail.keyPath }}</span>
                            </td>
                            <td
                              [attr.data-label]="
                                'DEBUG_FLOW_CONDITION_PRODUCT_HAS_VALUE'
                                  | translate: { id: productDebugData?.data?.product?.id || productId }
                              "
                            >
                              <span class="flow-condition-product-value">
                                @if (detail.hasProductValue) {
                                  {{ detail.productValueDisplay }}
                                } @else {
                                  <span class="fst-italic text-muted">{{
                                    'DEBUG_FLOW_CONDITION_MISSING_VALUE' | translate
                                  }}</span>
                                }
                              </span>
                              @if (detail.match === 'yes') {
                                <i class="fa-solid fa-circle-check text-success ms-1"></i>
                              } @else if (detail.match === 'no') {
                                <i class="fa-solid fa-circle-xmark text-danger ms-1"></i>
                              }
                            </td>
                            <td [attr.data-label]="'DEBUG_FLOW_CONDITION_FLOW_INCLUDES' | translate">
                              <span class="badge rounded-pill bg-secondary me-2">{{ detail.operatorLabel }}</span>
                              <span class="flow-condition-allowed">{{ detail.allowedValuesDisplay }}</span>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>
          }

          <div class="settings-row">
            <span class="settings-label">{{ 'PRODUCT_FILTERED_OUT_BECAUSE_FLOW_REQUIRES_AVAILABILITY' | translate }}</span>
            @if (productDebugData.flow?.requireCurrentAvailability && (productAvailability?.currentAvailability || 0) === 0) {
              <span class="settings-check settings-check-fail">{{ 'YES' | translate }} <i class="fa-solid fa-circle-xmark"></i></span>
            } @else {
              <span class="settings-check settings-check-ok">{{ 'NO' | translate }} <i class="fa-solid fa-circle-check"></i></span>
            }
          </div>

          <div class="settings-row">
            <span class="settings-label">{{ 'PRODUCT_FILTERED_OUT_BECAUSE_FLOW_REQUIRES_FUTURE_AVAILABILITY' | translate }}</span>
            @if (productDebugData.flow?.requireAvailability && (productAvailability?.maxFutureStock || 0) === 0) {
              <span class="settings-check settings-check-fail">{{ 'YES' | translate }} <i class="fa-solid fa-circle-xmark"></i></span>
            } @else {
              <span class="settings-check settings-check-ok">{{ 'NO' | translate }} <i class="fa-solid fa-circle-check"></i></span>
            }
          </div>
        </div>
      </div>

      <div class="row row-cols-1 row-cols-lg-3 g-3 mt-1">
        <div class="col">
          <div class="settings-card h-100">
            <div class="settings-card-header">
              <span class="settings-title">{{ 'PRODUCT' | translate }}</span>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm ms-auto settings-json-btn"
                (click)="openJsonModal('PRODUCT', productDebugData.data?.product)"
              >
                <i class="fa-solid fa-code me-1"></i>{{ 'VIEW_JSON' | translate }}
              </button>
            </div>
            <div class="settings-card-body">
              <div class="settings-row">
                <span class="settings-label">{{ 'PRODUCT_ID' | translate }}</span>
                <span class="settings-value">{{ productDebugData.data?.product?.id }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'PRODUCT_NAME' | translate }}</span>
                <span class="settings-value">{{ productDebugData.data?.product?.name }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'PRODUCT_BLOCKED' | translate }}</span>
                <span class="settings-pill" [class.settings-pill-danger]="productDebugData.data?.product?.extra?.gungItems?.blocked">
                  {{ (productDebugData.data?.product?.extra?.gungItems?.blocked ? 'YES' : 'NO') | translate }}
                </span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'SALES_BLOCKED' | translate }}</span>
                <span class="settings-pill" [class.settings-pill-danger]="productDebugData.data?.product?.extra?.gungItems?.salesBlocked">
                  {{ (productDebugData.data?.product?.extra?.gungItems?.salesBlocked ? 'YES' : 'NO') | translate }}
                </span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'CURRENT_STOCK' | translate }}</span>
                <span class="settings-value settings-value-strong">{{ productAvailability?.currentStock ?? 0 }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'CURRENT_AVAILABILITY' | translate }}</span>
                <span class="settings-value settings-value-strong">{{ productAvailability?.currentAvailability ?? 0 }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'MAX_FUTURE_STOCK' | translate }}</span>
                <span class="settings-value settings-value-strong">{{ productAvailability?.maxFutureStock ?? 0 }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="settings-card h-100">
            <div class="settings-card-header">
              <span class="settings-title">{{ 'FLOW' | translate }}</span>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm ms-auto settings-json-btn"
                (click)="openJsonModal('FLOW', productDebugData.data?.flow)"
              >
                <i class="fa-solid fa-code me-1"></i>{{ 'VIEW_JSON' | translate }}
              </button>
            </div>
            <div class="settings-card-body">
              <div class="settings-row">
                <span class="settings-label">{{ 'ID' | translate }}</span>
                <span class="settings-value">{{ productDebugData.data?.flow?.id }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'NAME' | translate }}</span>
                <span class="settings-value">{{ productDebugData.data?.flow?.name }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'PRODUCT_FILTERED_OUT_BY_FLOW_PRODUCT_SETTINGS' | translate }}</span>
                <span class="settings-pill" [class.settings-pill-danger]="!productDebugData.flow?.isProductInFlow">
                  {{ (productDebugData.flow?.isProductInFlow ? 'NO' : 'YES') | translate }}
                </span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'GUNGFLOW_REQUIRE_AVAILABILITY' | translate }}</span>
                <span class="settings-pill">{{ (productDebugData.flow?.requireAvailability ? 'YES' : 'NO') | translate }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'GUNGFLOW_REQUIRE_CURRENT_AVAILABILITY' | translate }}</span>
                <span class="settings-pill">{{ (productDebugData.flow?.requireCurrentAvailability ? 'YES' : 'NO') | translate }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="settings-card h-100">
            <div class="settings-card-header">
              <span class="settings-title">{{ 'USER' | translate }}</span>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm ms-auto settings-json-btn"
                (click)="openJsonModal('USER', productDebugData.data?.user)"
              >
                <i class="fa-solid fa-code me-1"></i>{{ 'VIEW_JSON' | translate }}
              </button>
            </div>
            <div class="settings-card-body">
              <div class="settings-row">
                <span class="settings-label">{{ 'USERNAME' | translate }}</span>
                <span class="settings-value">{{ productDebugData.data?.user?.username }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'ASSORTMENT' | translate }}</span>
                <span class="settings-value">{{ productDebugData.data?.user?.assortment }}</span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'PRODUCT_EXISTS_IN_USER_ASSORTMENT' | translate }}</span>
                <span class="settings-pill" [class.settings-pill-danger]="!productDebugData.isInAssortment">
                  {{ (productDebugData.isInAssortment ? 'YES' : 'NO') | translate }}
                </span>
              </div>
              <div class="settings-row">
                <span class="settings-label">{{ 'MULTI_STOCKS' | translate }}</span>
                <span class="settings-value">{{ (productDebugData.data?.user?.managedMultistockIds || []).join(', ') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else if(loading && !productDebugData?.error) {
  <div class="row">
    <div class="col-12 d-flex justify-content-center">
      <i class="fas fa-spinner fa-spin fa-4x"></i>
    </div>
  </div>
} @else if (!!productDebugData?.error) {
  <div class="row mt-3">
    <div class="col-12">
      <div class="alert alert-danger" role="alert">
        <i class="fa-solid fa-triangle-exclamation me-2"></i>{{ productDebugData.error }}
      </div>
    </div>
  </div>
}
